import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';
import Tooltip from '../../../components/ui/Tooltip';
import { useProfile } from '../../../hooks';
import { isZohoAtsConfigured } from '../../../lib/utils/ats';
import { isZohoUploadFieldsEmpty } from '../../../lib/utils/zohoUploadFields';
import { cn } from '../../../utils/cn';

export const SYNC_NO_ATS_TOOLTIP =
  'Your ATS is not connected. Connect Zoho in Connect ATS to enable syncing.';

const SyncToAtsButton = ({
  onClick,
  loading = false,
  size = 'sm',
  fullWidth = false,
  className,
  label,
  showTooltip = true,
}) => {
  const { t } = useTranslation();
  const { profile, loading: profileLoading } = useProfile();
  const isAtsConfigured = isZohoAtsConfigured(profile);
  const hasNoUploadFields = isZohoUploadFieldsEmpty(profile?.zoho_upload_fields);
  const isCheckingProfile = profileLoading && profile === null;
  const isBusy = loading || isCheckingProfile;
  const isDisabled = isCheckingProfile || !isAtsConfigured || hasNoUploadFields;
  const buttonLabel = loading
    ? t('connectAts.uploading')
    : (label || t('connectAts.uploadButton'));

  const button = (
    <Button
      size={size}
      fullWidth={fullWidth}
      loading={isBusy}
      iconName="SquarePen"
      onClick={onClick}
      disabled={isDisabled}
      className={className}
    >
      {buttonLabel}
    </Button>
  );

  const tooltipContent = !isAtsConfigured
    ? t('candidates.syncNoAtsTooltip')
    : hasNoUploadFields
      ? t('connectAts.uploadNoFieldsTooltip')
      : null;

  if (tooltipContent && !isCheckingProfile && showTooltip) {
    return (
      <Tooltip
        content={tooltipContent}
        align="start"
        size="md"
        className={cn(fullWidth && 'flex-1 w-full')}
      >
        <span
          className={cn(
            'inline-flex cursor-not-allowed',
            fullWidth && 'w-full flex-1'
          )}
        >
          {button}
        </span>
      </Tooltip>
    );
  }

  return button;
};

export default SyncToAtsButton;
